import Config from '../config/config';
import axios from 'axios';
import { Modal } from 'antd';

const handleRequest = (req, interceptUnauhtorized) => {
  if (interceptUnauhtorized !== false) {
    interceptUnauhtorized = true
  }

  const instance = axios.create({
    baseURL: Config.base_url,
    headers: {
      'Authorization': "bearer " + localStorage.getItem("token"),
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
    params: req.params || {},
  });

  return new Promise((resolve, reject) => {
    instance.request(req).then(
      result => resolve(result),
      result => {
        if (interceptUnauhtorized === true) { // intercept when session dies
          if (result.response.status === 401) {
            Modal.error({
              title: 'Permission denied',
              content: 'Maybe you lost your session, try logging in again.',
              onOk: () => {
                localStorage.clear();
                window.location = '/'
              }
            })
          }

          if (result.response.status === 403) { // intercept when session dies
            window.location = '/403'
          }
        }

        reject(result)
      }
    )
  })
}

export { handleRequest };